var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "50 50 510 430",
    enableBackground: "new 0 0 622 518",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logos_and_symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "off_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "VER_3_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "VER_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "off_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_14_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_13_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_6_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_15_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__7_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_x33__2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33__1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_10_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x34__1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__6_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_11_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_12_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "One_color_version_-_White_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_9_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-1-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-2-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_4_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_3_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1_1_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_4_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_3_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2_2_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_1-1-1_2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_7_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D374B",
    d: "M357.303,200.838l23.665-40.154l63.785,99.348l0.03,19.065l-0.208-131.197 c-0.151-3.207-1.854-6.141-4.571-7.871L325.167,73.973c-2.686-1.32-6.093-1.306-8.774,0.041c-0.362,0.182-0.703,0.379-1.028,0.594 l-0.4,0.252l-111.468,64.595l-0.433,0.196c-0.556,0.256-1.118,0.581-1.646,0.959c-2.113,1.516-3.517,3.757-3.971,6.271 c-0.068,0.381-0.118,0.769-0.142,1.16l0.175,106.913l59.413-92.087c7.48-12.211,23.778-16.144,38.907-15.93l17.757,0.469 L208.933,315.193l12.333,7.101l105.878-174.718l46.798-0.17L268.337,326.533l44.008,25.312l5.258,3.024 c2.224,0.904,4.846,0.949,7.089,0.14l116.451-67.485l-22.264,12.901L357.303,200.838z M366.332,330.877l-44.449-69.762 l27.133-46.042l58.375,92.009L366.332,330.877z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#28A0F0",
    points: "321.883,261.115 366.332,330.877 407.392,307.082 349.017,215.073  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28A0F0",
    d: "M444.783,279.097l-0.03-19.065l-63.785-99.348l-23.665,40.154l61.576,99.587l22.264-12.901 c2.184-1.773,3.505-4.376,3.644-7.185L444.783,279.097z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M177.492,297.077l31.44,18.116l104.624-167.787l-17.757-0.469c-15.129-0.214-31.426,3.719-38.907,15.93 l-59.413,92.087l-19.988,30.711V297.077z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "373.941,147.406 327.144,147.576 221.266,322.294 258.273,343.602 268.337,326.533  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96BEDC",
    d: "M464.504,147.165c-0.391-9.787-5.69-18.747-13.991-23.963L334.171,56.297 c-8.211-4.135-18.469-4.14-26.693-0.003c-0.972,0.49-113.141,65.544-113.141,65.544c-1.552,0.744-3.047,1.631-4.454,2.637 c-7.41,5.311-11.927,13.563-12.391,22.63v138.561l19.988-30.711l-0.175-106.913c0.024-0.391,0.073-0.775,0.142-1.155 c0.451-2.516,1.856-4.76,3.971-6.276c0.528-0.378,114.612-66.414,114.975-66.596c2.682-1.347,6.089-1.361,8.774-0.041 l114.837,66.056c2.717,1.73,4.42,4.664,4.571,7.871v132.439c-0.139,2.809-1.249,5.411-3.433,7.185l-22.264,12.901l-11.487,6.657 l-41.06,23.795l-41.64,24.132c-2.243,0.81-4.865,0.765-7.089-0.14l-49.266-28.336l-10.064,17.068l44.274,25.491 c1.464,0.832,2.769,1.57,3.839,2.172c1.658,0.93,2.787,1.551,3.186,1.744c3.147,1.528,7.674,2.418,11.754,2.418 c3.741,0,7.388-0.687,10.84-2.039l120.945-70.043c6.942-5.378,11.026-13.489,11.394-22.276V147.165z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M90.158,429.297c1.279,0,2.356,0.261,3.231,0.782c0.876,0.522,1.734,1.541,2.577,3.057l16.719,30.357 c0.168,0.337,0.211,0.614,0.127,0.833c-0.084,0.22-0.328,0.328-0.732,0.328h-6.415c-0.572,0-0.959-0.219-1.162-0.656l-3.586-6.516 h-23.74l-3.486,6.516c-0.236,0.438-0.623,0.656-1.161,0.656h-6.565c-0.439,0-0.699-0.108-0.783-0.328 c-0.086-0.219-0.043-0.496,0.125-0.833l16.568-30.357c0.842-1.516,1.667-2.534,2.476-3.057c0.808-0.521,1.749-0.782,2.828-0.782 H90.158z M80.358,451.623h17.376l-8.031-14.8c-0.135-0.235-0.321-0.354-0.556-0.354h-0.303c-0.236,0-0.422,0.119-0.556,0.354 L80.358,451.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M165.727,429.297c3.872,0,6.65,0.876,8.335,2.627c1.683,1.751,2.525,4.344,2.525,7.778v2.879 c0,2.896-0.59,5.187-1.768,6.87c-1.18,1.684-3.1,2.761-5.759,3.232l8.638,10.709c0.168,0.169,0.218,0.421,0.151,0.757 c-0.068,0.337-0.338,0.505-0.808,0.505h-6.517c-0.438,0-0.742-0.05-0.909-0.15c-0.169-0.102-0.337-0.27-0.505-0.506l-7.981-10.506 h-16.315v10.051c0,0.742-0.371,1.111-1.111,1.111h-5.455c-0.774,0-1.162-0.369-1.162-1.111v-32.73 c0-1.011,0.506-1.516,1.517-1.516H165.727z M144.815,447.329h19.347c1.717,0,2.93-0.37,3.636-1.111 c0.708-0.74,1.062-1.868,1.062-3.384v-2.122c0-1.515-0.354-2.644-1.062-3.384c-0.706-0.74-1.919-1.111-3.636-1.111h-18.69 c-0.438,0-0.656,0.202-0.656,0.606V447.329z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M233.074,429.297c3.47,0,5.936,0.69,7.4,2.071c1.466,1.38,2.197,3.468,2.197,6.263v2.425 c0,2.829-1.077,4.967-3.231,6.415c2.322,1.347,3.484,3.52,3.484,6.516v2.93c0,1.348-0.152,2.561-0.455,3.638 s-0.8,1.994-1.489,2.753c-0.69,0.757-1.608,1.338-2.753,1.742c-1.146,0.404-2.56,0.605-4.244,0.605H203.98 c-1.011,0-1.517-0.505-1.517-1.515v-32.327c0-1.011,0.506-1.516,1.517-1.516H233.074z M210.192,443.995h20.711 c1.684,0,2.828-0.252,3.435-0.757c0.605-0.506,0.909-1.246,0.909-2.224v-1.717c0-1.044-0.295-1.81-0.884-2.299 c-0.59-0.487-1.54-0.731-2.854-0.731h-20.66c-0.438,0-0.657,0.22-0.657,0.656V443.995z M210.192,449.501v7.526 c0,0.438,0.219,0.657,0.657,0.657h20.71c1.348,0,2.307-0.245,2.879-0.732c0.573-0.487,0.858-1.271,0.858-2.349v-1.92 c0-1.044-0.312-1.835-0.934-2.374c-0.624-0.538-1.776-0.809-3.46-0.809H210.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M274.984,429.297c0.741,0,1.112,0.37,1.112,1.111v33.135c0,0.742-0.371,1.111-1.112,1.111h-5.456 c-0.774,0-1.161-0.369-1.161-1.111v-33.135c0-0.741,0.387-1.111,1.161-1.111H274.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M341.133,429.297c0.774,0,1.162,0.37,1.162,1.111v4.949c0,0.775-0.388,1.162-1.162,1.162h-15.86v27.023 c0,0.742-0.371,1.111-1.112,1.111h-5.505c-0.741,0-1.11-0.369-1.11-1.111V436.52h-15.861c-0.775,0-1.162-0.387-1.162-1.162v-4.949 c0-0.741,0.387-1.111,1.162-1.111H341.133z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M395.311,429.297c3.873,0,6.652,0.876,8.336,2.627c1.683,1.751,2.525,4.344,2.525,7.778v2.879 c0,2.896-0.59,5.187-1.768,6.87c-1.18,1.684-3.1,2.761-5.759,3.232l8.638,10.709c0.168,0.169,0.218,0.421,0.15,0.757 c-0.067,0.337-0.336,0.505-0.807,0.505h-6.517c-0.438,0-0.741-0.05-0.909-0.15c-0.169-0.102-0.337-0.27-0.505-0.506l-7.981-10.506 H374.4v10.051c0,0.742-0.371,1.111-1.111,1.111h-5.455c-0.774,0-1.162-0.369-1.162-1.111v-32.73c0-1.011,0.506-1.516,1.517-1.516 H395.311z M374.4,447.329h19.347c1.717,0,2.93-0.37,3.636-1.111c0.708-0.74,1.062-1.868,1.062-3.384v-2.122 c0-1.515-0.354-2.644-1.062-3.384c-0.706-0.74-1.919-1.111-3.636-1.111h-18.69c-0.438,0-0.656,0.202-0.656,0.606V447.329z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M437.928,429.297c0.74,0,1.111,0.37,1.111,1.111v20.154c0,1.347,0.109,2.467,0.328,3.358 c0.219,0.893,0.582,1.6,1.086,2.121c0.506,0.523,1.188,0.894,2.047,1.111c0.858,0.22,1.944,0.329,3.258,0.329h13.991 c1.313,0,2.399-0.109,3.258-0.329c0.859-0.218,1.54-0.588,2.046-1.111c0.505-0.521,0.859-1.229,1.061-2.121 c0.202-0.892,0.303-2.012,0.303-3.358v-20.154c0-0.741,0.371-1.111,1.111-1.111h5.506c0.74,0,1.111,0.37,1.111,1.111v20.911 c0,2.425-0.252,4.487-0.758,6.188c-0.504,1.7-1.321,3.081-2.449,4.142c-1.129,1.061-2.593,1.827-4.395,2.298 c-1.801,0.473-3.982,0.707-6.541,0.707h-14.547c-2.561,0-4.731-0.234-6.517-0.707c-1.785-0.471-3.242-1.237-4.369-2.298 c-1.128-1.061-1.954-2.441-2.476-4.142c-0.521-1.701-0.783-3.764-0.783-6.188v-20.911c0-0.741,0.387-1.111,1.162-1.111H437.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M510.125,429.297c0.741,0,1.38,0.05,1.919,0.151c0.539,0.101,1.011,0.295,1.414,0.581 c0.405,0.286,0.766,0.674,1.086,1.162c0.319,0.487,0.648,1.136,0.986,1.944l10.506,24.245c0.133,0.304,0.371,0.455,0.707,0.455 h0.605c0.337,0,0.573-0.151,0.708-0.455l10.506-24.245c0.337-0.809,0.665-1.457,0.985-1.944c0.319-0.488,0.682-0.876,1.085-1.162 c0.405-0.286,0.867-0.48,1.39-0.581c0.522-0.102,1.153-0.151,1.895-0.151h5.405c1.75,0,2.929,0.396,3.534,1.187 c0.607,0.792,0.91,2.147,0.91,4.066v28.993c0,0.742-0.387,1.111-1.161,1.111h-5.151c-0.742,0-1.112-0.369-1.112-1.111v-26.367 c0-0.336-0.135-0.505-0.405-0.505h-0.454c-0.337,0-0.556,0.136-0.657,0.404l-10.202,22.63c-0.403,0.908-0.817,1.676-1.238,2.298 c-0.421,0.624-0.875,1.137-1.362,1.54c-0.489,0.404-1.045,0.691-1.668,0.859c-0.623,0.169-1.355,0.252-2.197,0.252h-2.424 c-0.844,0-1.575-0.083-2.197-0.252c-0.624-0.168-1.18-0.455-1.668-0.859c-0.488-0.403-0.943-0.916-1.363-1.54 c-0.421-0.622-0.833-1.39-1.237-2.298l-10.204-22.63c-0.101-0.269-0.319-0.404-0.656-0.404h-0.455 c-0.27,0-0.403,0.169-0.403,0.505v26.367c0,0.742-0.371,1.111-1.111,1.111h-5.152c-0.774,0-1.162-0.369-1.162-1.111V434.55 c0-1.919,0.304-3.274,0.909-4.066c0.607-0.79,1.801-1.187,3.587-1.187H510.125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_8_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-1-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-2-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_2-3-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-1_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-2_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SYMBOL_VER_5-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Monochromatic_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__4_"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.e038199b.svg";
export { ForwardRef as ReactComponent };